import React, { useState } from "react";
import PropTypes from "prop-types";
import SliderRangeFilter from "../../components/Slider";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import { categoryOrBrand } from "../../utils/categoryOrBrand";
import { useSelector, useDispatch } from "react-redux";
import { selectBrands, selectCategories, setOrder } from "../../Redux/filterSlice";
import { useApp } from "../../contexts/AppContext";

const BUTTON_LABELS = {
  relevant: "mais-relevantes",
  discount_desc: "maiores-descontos",
  smaller: "menor-preco",
  larger: "maior-preco",
  label_asc: "ordem-alfabetica-a-z",
  label_desc: "ordem-alfabetica-z-a",
};

const labelStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  fontSize: "14px",
  color: "var(--light-color)",
};
const h3Style = { margin: "0 0 16px 0", fontSize: "16px", fontWeight: "600", color: "var(--primary-color)" };
const dividerStyle = { height: "1px", backgroundColor: "#e0e0e0", margin: "0 0 24px 0" };

const ORDER_OPTIONS = [
  { value: "relevant", redux: "relevant", label: "Mais relevantes" },
  { value: "discount_desc", redux: "discount_desc", label: "Maiores descontos" },
  { value: "smaller", redux: "price_asc", label: "Menor preço" },
  { value: "larger", redux: "price_desc", label: "Maior preço" },
  { value: "label_asc", redux: "label_asc", label: "Ordem alfabética (A - Z)" },
  { value: "label_desc", redux: "label_desc", label: "Ordem alfabética (Z - A)" },
];

export default function FilterContent({
  target,
  onClickBrand,
  onClickCategory,
  onApply,
  onClear,
  variant,
}) {
  const categories = useSelector(selectCategories);
  const brands = useSelector(selectBrands);
  const [order, setOrderValue] = useState(
    () => localStorage.getItem("orderFilter") || "relevant"
  );
  const { whitelabel } = useApp();
  const [displayMode] = useState(whitelabel?.config?.payment_mode);
  const disp = useDispatch();
  const screenTracking = useScreenTracking();
  const getFilterType = categoryOrBrand(categories, brands);
  const isModal = variant === "modal";

  const handleOrderChange = (value, reduxValue) => {
    trackClick({
      title: BUTTON_LABELS[value] || value,
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("04"),
    });
    setOrderValue(value);
    localStorage.setItem("orderFilter", value);
    disp(setOrder({ order: reduxValue }));
  };

  const showBrands = ["Marcas", "Produtos"].indexOf(target) >= 0 && brands.length > 0;
  const showCategories = ["Categorias", "Produtos"].indexOf(target) >= 0 && categories.length > 0;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        ...(isModal ? { height: "100%" } : { flex: 1 }),
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 20px",
          borderBottom: "1px solid #e0e0e0",
          flexShrink: 0,
        }}
      >
        <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "var(--primary-color)" }}>
          {isModal ? "Filtrar" : "Filtros"}
        </h2>
      </div>

      <div
        style={{ padding: "20px", flex: 1, minHeight: 0, overflowY: "auto", WebkitOverflowScrolling: "touch" }}
      >
        <div style={{ marginBottom: "24px" }}>
          <h3 style={h3Style}>Ordenado por</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {ORDER_OPTIONS.map((opt) => (
              <label key={opt.value} style={labelStyle}>
                <input
                  type="radio"
                  name="order"
                  value={opt.value}
                  checked={order === opt.value}
                  onChange={() => handleOrderChange(opt.value, opt.redux)}
                  style={{ accentColor: "var(--primary-color)" }}
                />
                {opt.label}
              </label>
            ))}
          </div>
        </div>

        <div style={dividerStyle} />

        <div style={{ marginBottom: "24px" }}>
          <SliderRangeFilter mode={displayMode} brands={brands} />
        </div>

        <div style={dividerStyle} />

        {showBrands && (
          <>
            <div style={{ marginBottom: "24px" }}>
              <h3 style={h3Style}>Marcas</h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {brands.map((item) => (
                  <label key={item.id} style={labelStyle}>
                    <input
                      type="checkbox"
                      checked={item.check}
                      onChange={() => onClickBrand(item.id)}
                      style={{ accentColor: "var(--primary-color)" }}
                    />
                    {item.label}
                  </label>
                ))}
              </div>
            </div>
            <div style={dividerStyle} />
          </>
        )}

        {showCategories && (
          <div style={{ marginBottom: "24px" }}>
            <h3 style={h3Style}>Categorias</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {categories.map((item) => (
                <label key={item.id} style={labelStyle}>
                  <input
                    type="checkbox"
                    checked={item.check}
                    onChange={() => onClickCategory(item.id)}
                    style={{ accentColor: "var(--primary-color)" }}
                  />
                  {item.label}
                </label>
              ))}
            </div>
          </div>
        )}
      </div>

      <div
        style={{
          padding: "20px",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          flexShrink: 0,
        }}
      >
        <button
          onClick={onApply}
          style={{
            backgroundColor: "var(--primary-color)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "8px",
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          FILTRAR
        </button>
        <button
          onClick={onClear}
          style={{
            backgroundColor: "white",
            color: "var(--primary-color)",
            border: "1px solid var(--primary-color)",
            borderRadius: "8px",
            padding: "8px",
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          LIMPAR FILTRO
        </button>
      </div>
    </div>
  );
}

FilterContent.propTypes = {
  target: PropTypes.string,
  onClickBrand: PropTypes.func,
  onClickCategory: PropTypes.func,
  onApply: PropTypes.func,
  onClear: PropTypes.func,
  variant: PropTypes.oneOf(["modal", "sidebar"]),
};

FilterContent.defaultProps = {
  variant: "modal",
};
